export default __webpack_public_path__ + "static/media/02-manufacturing.bfb1fbb6.jpg";